import React, { useCallback, useEffect } from 'react';
import block from 'bem-cn';
// import PT from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom';
import dayjs from 'dayjs';

import SVG from 'components/SVG';
import Button from 'components/Button';
import BithidePaymentInfoPending from './BithidePaymentInfoPending';
import BackBlock from 'components/BackBlock';
import Spinner from 'components/Spinner';

import { actions as paymentActions } from 'features/payment';

import { getTimer } from 'shared/helpers/getTimer';

import failedSVG from './img/failed.svg';

import './BithidePaymentInfo.scss';

const b = block('bithide-payment-info');

const BithidePaymentInfo = () => {
  const dispatch = useDispatch();

  const match = useRouteMatch();

  const { locale } = useSelector(state => state.locale);
  const {
    actionProcessing,
    depositInfo: {
      paidAt,
      createdAt,
      status,
    },
  } = useSelector(state => state.payment);

  const getDepositInfo = useCallback(() => {
    const paymentId = match.params?.paymentId;
    if (paymentId) {
      dispatch(paymentActions.getDepositInfo({
        requestData: {
          depositId: paymentId,
        }
      }))
    }
  }, [match, dispatch]);

  useEffect(() => {
    getDepositInfo();
  }, [getDepositInfo]);

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <BackBlock />
      <h1 className={b('title')}>{locale.payment}</h1>
      <div className={b('wrapper')}>
        {status === 0 && (
          <BithidePaymentInfoPending getDepositInfo={getDepositInfo} />
        )}
        {status === 1 && (<>
          <p className={b('result-title')}>
            {locale.congratulationsTheFundsHaveBeenCredited}
          </p>
          <div className={b('timer')}>
            <p className={b('timer-text')}>
              {locale.timeSpent}
            </p>
            <p className={b('timer-value')}>
              {getTimer(dayjs(paidAt), dayjs(createdAt))}
            </p>
          </div>
        </>)}
        {(status === 2 || status === 3) && (<>
          <SVG className={b('icon')} svgProps={{ svg: failedSVG }} />
          <p className={b('result-title')}>
            {locale.replenishmentFailed}
          </p>
        </>)}
      </div>
      {(status === 2 || status === 3) && (
        <div className={b('button')}>
          <Button link="/payment/bithide" text={locale.topUpAgain} />
        </div>
      )}
    </div>
  );
};

BithidePaymentInfo.propTypes = {};

export default BithidePaymentInfo;
